<template>
    <div>
        <h2>Recent Files</h2>
        <ol>
            <li v-for="file in recentFiles" :key="file.code">
                {{ file.code }} : <router-link :to="{ name: 'FSEditor'}"><span @click="setCompanyCode(file.code)">{{ file.name }}</span></router-link>
            </li>
        </ol>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'recent',
    computed: {
        ...mapState(['recentFiles'])
    },
    created() {
        this.$store.dispatch('fetchRecentFiles')
    },
    methods: {
        setCompanyCode: function(companyCode) {
            this.$store.dispatch('setCompanyCode', companyCode)
        }
    }
}
</script>

<style>
li {
    list-style-type: none;
}
ol {
    padding-left: 0;
}
</style>